import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import TitleBar from "../../../partials/content/TitleBar";

function AllPreviewIndependentPositionsSitePublisher() {
  const params = useParams();
  const sitePublisherID = parseInt(params.id);

  const [positions, setPositions] = useState([]);
  const [imageSrc, setImageSrc] = useState();
  const [sitePublisherData, setSitePublisherData] = useState();

  useEffect(() => {
    const initDataComponent = async () => {
      await getSitePublisher();
      await getImageIndependentSitePublisher();
      await getIndependentPositions();
      scrollForSeeMessage();
    };
    initDataComponent();
  }, []);

  const scrollForSeeMessage = () => {
    const element = document.querySelector("#select-position-container");
    element.scrollIntoView();
  };

  const getImageIndependentSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const image = await sendRequestGetImageIndependentPositionsSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!image) {
      return;
    }

    setImageSrc(image.src);
  };

  const sendRequestGetImageIndependentPositionsSitePublisher = async (
    sitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let image;
    try {
      image = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/position/image-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return image.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitePublisher) {
      return;
    }
    setSitePublisherData(sitePublisher);
  };

  const sendRequestGetSitePublisher = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let positionsPageSitePublisher;
    try {
      positionsPageSitePublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return positionsPageSitePublisher.data.data;
  };

  const getIndependentPositions = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const independentPositions = await sendRequestGetIndependentPositions(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!independentPositions) {
      return;
    }

    setPositions(independentPositions);
  };

  const sendRequestGetIndependentPositions = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let independentPositions;
    try {
      independentPositions = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/demo/position/all-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return independentPositions.data.data;
  };

  const generatePositionsPageSitePublisher = () => {
    return (
      <>
        <div className="col-12 pt-2">
          <div className="alert alert-warning ">
            <p>
              <i className="fa fa-info pl-2"></i>
              توجه داشته باشید :{" "}
            </p>
            <ul className="pr-3">
              <li>
                <p>
                  در تصویر زیر میتوانید جایگاه های تبلیغاتی هایلات را در صفحه
                  مدنظر مشاهده نمایید.
                </p>
              </li>
            </ul>
          </div>
        </div>

        {positions.map((position, index) => {
          return (
            <div
              key={index}
              className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 select-position-in-page-box py-2"
            >
              <div className="bg-info">
                <div className="p-2 d-flex">
                  <div className="align-items-center justify-content-center d-flex flex-grow-1">
                    <span>اطلاعات جایگاه</span>
                    <span className="px-2">-</span>
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(position.id)}
                    </span>
                  </div>
                </div>

                <div className=" d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    اندازه
                  </div>
                  <div className="py-2 w-50 text-center">
                    <span className="letter-spacing-finance-number" dir="ltr">
                      {helpersNumbers.toPersianNum(
                        position.size.replace("-", "×")
                      )}
                    </span>
                    <span className="pr-2">پیکسل</span>
                  </div>
                </div>

                <div className=" d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    ظرفیت کل
                  </div>
                  <div className="py-2 w-50 text-center">
                    {helpersNumbers.toPersianNum(position.count)}
                    <span className="pr-2">بنر</span>
                  </div>
                </div>
                <div className=" d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    سهم شما
                  </div>
                  <div className="py-2 w-50 text-center">
                    {helpersNumbers.toPersianNum(1)}
                    <span className="pr-2">بنر</span>
                  </div>
                </div>

                <div className=" d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    ارزش کل
                  </div>
                  <div className="py-2 w-50 text-center ">
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(
                          position.base_price
                        )
                      )}
                    </span>
                    <span className="pr-2">تومان</span>
                  </div>
                </div>

                <div className=" d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    پرداختی شما
                  </div>
                  <div className="py-2 w-50 text-center ">
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        helpersNumbers.toFormatFinanceNumber(position.price)
                      )}
                    </span>

                    <span className="pr-2">تومان</span>
                  </div>
                </div>

                <div className="px-2 d-flex border-top">
                  <div className="py-2 w-50 text-center border-left">
                    سهم نمایش
                  </div>
                  <div className="py-2 w-50 text-center ">
                    <span className="letter-spacing-finance-number">
                      {helpersNumbers.toPersianNum(
                        Math.floor((1 / position.count) * 100)
                      )}
                    </span>
                    <span className="pr-2">درصد</span>
                  </div>
                </div>

                <div dir="ltr" className="p-2 text-center border-top">
                  {position.tag_html_id}
                </div>
              </div>
            </div>
          );
        })}
        <div className="form-group pt-2">
          <div>
            <a href={imageSrc} target="_blank">
              <img className="border border-success img-fluid" src={imageSrc} />
            </a>
          </div>
        </div>
      </>
    );
  };

  const generatePageDoseNotHaveAnyPositions = () => {
    return (
      <div className="d-flex flex-column flex-md-row">
        <div className="text-center text-md-right">
          <img src="/assets/img/do-not-have-position.svg" />
        </div>
        <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p>این سایت هیچ جایگاهی مستقلی ندارد.</p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar
          title={` جایگاه های مستقل سایت
          ${sitePublisherData?.url.replace("http://", "")}`}
        />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="container-fluid" id="select-position-container">
                <div className="row">
                  <div className="col-12">
                    <div className="text-left">
                      <Link
                        className="btn btn-primary"
                        to={`/publishers/preview/${sitePublisherData?.id}/all-page`}
                      >
                        <span>بازگشت</span>
                        <span className="pr-2">
                          <i className="fas fa-arrow-left"></i>
                        </span>
                      </Link>
                    </div>
                  </div>

                  {positions.length !== 0
                    ? generatePositionsPageSitePublisher(positions)
                    : generatePageDoseNotHaveAnyPositions()}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllPreviewIndependentPositionsSitePublisher;
